module.exports = __webpack_public_path__ + "static/media/off_centered_buttonless.853aaf26.svg";